import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthGuardService  {

  constructor(private router: Router, private auth: AuthService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    this.auth.redirectUrl = state.url;
    if (sessionStorage.getItem('access_token') && sessionStorage.getItem('policyDetails')) {
      return true;
    }
    if(sessionStorage.getItem('access_token')){
      return true;
    }

    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
  }
}
